import React from 'react';
import { Form,Menu, Segment, Message, Input, Label, Select, Radio, Button, Popup, Grid } from 'semantic-ui-react';
import CurrencyInput from 'react-currency-input';
import 'react-datepicker/dist/react-datepicker.css';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import RincianList from './RincianList';
import { getOptRek2, getOptRek3, getOptRek4, getOptRek5, getOptRek6 } from '../../../../../_utils/getrekening';
import { toIDR } from '../../../../../_utils/tocurrency';
import STSAdd from './_addsts/STSAdd';
import swal from 'sweetalert';

export default class BPAdd extends React.Component {
   
   constructor(props){
      super(props);
      this.state = {
         parafs: [],
         data: {
            rincian: [],
            paraf: "",
            nama_penyetor: "",
            alamat_penyetor: "",
            uraian: "",
         },
         loading: false,
         error: false,
         error_rinc: false,
         opt_rek_2: null,
         opt_rek_3: null,
         opt_rek_4: null,
         opt_rek_5: null,
         opt_rek_6: null,

         status_rek_2: false,
         status_rek_3: true,
         status_rek_4: true,
         status_rek_5: true,
         status_rek_6: true,

         temp: {
            manual: {
                  kd_rek_2: "",
                  kd_rek_3: "",
                  kd_rek_4: "",
                  kd_rek_5: "",
                  kd_rek_6: "",
               },
            select: {
                  kd_rek_2: "",
                  kd_rek_3: "",
                  kd_rek_4: "",
                  kd_rek_5: "",
                  kd_rek_6: "",
               },
            nilai: "",
            uraian_rinc: "",
            str_kd_rek: "",
         },

         is_manual: true,
         is_detail: false,
         render_detail: false,

         kd_rek: "",
         label_rekening: null,
         requests_label: false,

         header_message: "",

         data_bp: null,
         is_open: false,
         loading_open: false,
         disabled_btn_save: false,
         kd_rek_true: true,
         kd_rek_temp: "",
         optrek3: null,
         optrek4: null,
         optrek5: null,
         optrek6: null,
         temp_str_kd_rek: [],
         is_edit: false
      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onChangeRek2 = this.onChangeRek2.bind(this);
      this.onChangeRek3 = this.onChangeRek3.bind(this);
      this.onChangeRek4 = this.onChangeRek4.bind(this);
      this.onChangeRek5 = this.onChangeRek5.bind(this);
      this.onChangeRek6 = this.onChangeRek6.bind(this);
      this.onSubmitRincian = this.onSubmitRincian.bind(this);
      this.onChangeNilai = this.onChangeNilai.bind(this);
      this.onToggleRadio = this.onToggleRadio.bind(this);
      this.removeRinc = this.removeRinc.bind(this);
      this.editRinc = this.editRinc.bind(this);
      this.onChangeParaf = this.onChangeParaf.bind(this);
      this.resetState = this.resetState.bind(this);
      this.onReset = this.onReset.bind(this);
      this.onCloseAddSTS = this.onCloseAddSTS.bind(this);
      this.onOpenAddSTS = this.onOpenAddSTS.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this)
      
   }

   handleKeyPress(event){
      if(event.key == '/' || event.key == '%' || event.key == "'" || event.key == '"'){
         swal("Maaf, penggunaan spesial karakter (\"\, \'\, %, /) pada isian nama atau keterangan diblock", {
            icon: "warning",
         });
      }
   }

   getParafData(){
      fetch(`${BaseURLDev}/paraf`, { headers })
      .then(response => {
         if(!response.ok){
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const parafs = []
         resJSON.data.map((item,i)=>{
            parafs.push({
               'value': item.id,
               'text': `[${item.kode}] ${item.nama}`,
               'key': i      
            })
            return false
         })
         this.setState({parafs:parafs})
         return false
      })
   }

   onToggleRadio(){
      // if(this.state.rekening_error)
         // this.statusSelect(false, false, false, false);
      // else
      this.clearSelect(true, true, true, true);

      this.clearSelect(true, true, true, true);
      
      getOptRek2()
      .then(resRek => {
         this.setState({opt_rek_2: resRek.data});
         // this.statusSelect(true, true, true, true);
         // this.clearSelect(true, true, true, true);
      });
      if(this.state.is_edit){
         this.setState({
            is_manual: !this.state.is_manual,
            label_rekening: null,
            // kd_rek: "",
         });
      }else{
         this.setState({
            is_manual: !this.state.is_manual,
            label_rekening: null,
            kd_rek: "",
         });
      }
   }

   editRinc(item, index){
      const { rincian } = this.state.data;
      const { temp_str_kd_rek } = this.state;
      const rinciEdit = rincian[index];
      const rekening = "4."+rinciEdit.kd_rek_2+"."+rinciEdit.kd_rek_3+"."+rinciEdit.kd_rek_4+"."+rinciEdit.kd_rek_5+"."+rinciEdit.kd_rek_6;
      this.setState({
         is_manual: true,
         kd_rek: rekening,
         is_edit: true,
         temp: {
            ...this.state.temp,
            nilai: rinciEdit.nilai,
            uraian_rinc: rinciEdit.uraian_rinc ? rinciEdit.uraian_rinc : "",
            manual: {
               ...this.state.temp.manual,
               kd_rek_2: rinciEdit.kd_rek_2,
               kd_rek_3: rinciEdit.kd_rek_3,
               kd_rek_4: rinciEdit.kd_rek_4,
               kd_rek_5: rinciEdit.kd_rek_5,
               kd_rek_6: rinciEdit.kd_rek_6,
            }
         }
      })
      
      let str_kd_rek = rincian[index].str_kd_rek;
      var index_data = null;
      for(let i=0; i<temp_str_kd_rek.length; i++) {
         if(temp_str_kd_rek[i] === str_kd_rek){
            index_data = i;
            break;
         }
      }
      const temp_str_rek_Remove = temp_str_kd_rek.slice();
      temp_str_rek_Remove.splice(index_data, 1);
      this.setState({ temp_str_kd_rek: temp_str_rek_Remove })

      
      const rinciRemove = rincian.slice();
      rinciRemove.splice(index, 1);
      this.setState({ data: { ...this.state.data, rincian: rinciRemove } })
   }

   componentDidMount(){
      this.getParafData();
   }

   onSubmit(e){
      this.setState({ disabled_btn_save: true });
      const { rincian, nama_penyetor, alamat_penyetor, paraf, uraian } = this.state.data;
      e.preventDefault();
      if(rincian.length < 1){
         swal("", "Maaf rincian rekening belum ditambahkan", "error")
         this.setState({disabled_btn_save: false});
      }
      else if(alamat_penyetor===null || alamat_penyetor===""){
         swal("", "Alamat penyetor harus diisi terlebih dahulu", "error")
         this.setState({disabled_btn_save: false});
      }else if(paraf===null || paraf===""){
         swal("", "Pejabat/pegawai paraf harus dipilih terlebih dahulu", "error")
         this.setState({disabled_btn_save: false});
      }else if(uraian==="" || uraian===null){
         swal("", "Keterangan harus diisi terlebih dahulu", "error")
         this.setState({disabled_btn_save:false});
      }else if(nama_penyetor==="" || nama_penyetor===null){
         swal("", "Nama penyetor harus diisi terlebih dahulu", "error")
         this.setState({disabled_btn_save:false});
      }else{
         this.setState({loading:true, disabled_btn_save:true});
         fetch(`${BaseURLDev}/bp`,{
            method: 'POST',
            body: JSON.stringify(this.state.data),
            headers
         })
         .then(response => {

            if (!response.ok) { 
               swal("", "Pembuatan BP gagal", "error")
               this.setState({loading: false, disabled_btn_save: false});
               return Promise.reject(response.statusText);
            }
            else{
               this.resetState()
               swal("", "Pembuatan BP selesai", "success")
            }
            // return response.json();
         })
         //.then(parsedJSON => this.setState({data:parsedJSON.data, requests:false}))
         // .then(response => {
         //    console.log(response)
         // })response.json()){
         // })
      }
   }

   resetState(){
      this.clearSelect(true, true, true, true);
      this.statusSelect(false, true, true, true);
      this.setState({
         disabled_btn_save: false,
         loading: false,
         data: {...this.state.data,
            rincian: [],
            nama_penyetor: "",
            alamat_penyetor: "",
            uraian: "",
            paraf: null,
         },
         parafs: null,
         temp_str_kd_rek: []
      });

      this.getParafData();
   }

   onSubmitRincian(e){
      const { kd_rek_true, is_manual, data, temp_str_kd_rek, kd_rek } = this.state;
      const { rincian } = this.state.data;
      const { nilai, uraian_rinc, select, manual } = this.state.temp;
      e.preventDefault();
      
      if(is_manual){
         if(kd_rek !== ""){

            const { kd_rek_2, kd_rek_3, kd_rek_4, kd_rek_5, kd_rek_6 } = manual;
            const kd_rek_123456 = `4.${kd_rek_2}.${kd_rek_3}.${kd_rek_4}.${kd_rek_5}.${kd_rek_6}`;

            if(!kd_rek_true || kd_rek_2==="" || kd_rek_3==="" || kd_rek_4==="" || kd_rek_5==="" || kd_rek_6==="" || nilai==="" || uraian_rinc===""){
               swal("", "Data rincian rekening belum lengkap", "error");
               return false;
            }else{
               if(rincian.length>0){
                  for(let i=0; i<temp_str_kd_rek.length; i++) {
                     if(temp_str_kd_rek[i] === kd_rek_123456){
                        swal({
                           title: `Rekening ${kd_rek_123456} sudah ada di rincian ini`,
                           text: "Apakah anda tetap melanjutkan?",
                           icon: "warning",
                           buttons: true,
                           dangerMode: true,
                        })
                        .then((will) => {
                           if (will) {
                              const newRincian = rincian.slice();
                              newRincian[i].nilai = newRincian[i].nilai+nilai;
                              newRincian[i].uraian_rinc = `${newRincian[i].uraian_rinc}, ${uraian_rinc}`;
                              this.setState({
                                 data:{
                                    ...data,
                                    rincian: newRincian
                                 },
                              });
                           }
                           this.clearRincian();
                           return false;
                        });
                        return false;
                     }
                  }
                  this.setState({
                     data: {
                        ...data,
                        rincian: [
                           ...rincian, 
                           {
                              nilai: nilai,
                              uraian_rinc: uraian_rinc,
                              kd_rek_2: kd_rek_2,
                              kd_rek_3: kd_rek_3,
                              kd_rek_4: kd_rek_4,
                              kd_rek_5: kd_rek_5,
                              kd_rek_6: kd_rek_6,
                              str_kd_rek: kd_rek_123456,
                           }
                        ],
                     },
                     temp_str_kd_rek: [...this.state.temp_str_kd_rek, kd_rek_123456],
                  });
                  this.clearRincian();
                  return false;
               }
               else
               {
                  this.setState({
                     data: {
                        ...data,
                        rincian: [
                           ...rincian, 
                           {
                              nilai: nilai,
                              uraian_rinc: uraian_rinc,
                              kd_rek_2: kd_rek_2,
                              kd_rek_3: kd_rek_3,
                              kd_rek_4: kd_rek_4,
                              kd_rek_5: kd_rek_5,
                              kd_rek_6: kd_rek_6,
                              str_kd_rek: kd_rek_123456,
                           }
                        ],
                     },
                     temp_str_kd_rek: [...this.state.temp_str_kd_rek, kd_rek_123456],
                  });
               }               
               this.clearRincian();
            }
         }else{
            swal("", "Kode rekening belum diisi", "error");
            return false;
         }
      }else{

         const { kd_rek_2, kd_rek_3, kd_rek_4, kd_rek_5, kd_rek_6 } = select;
         const kd_rek_123456 = `4.${kd_rek_2}.${kd_rek_3}.${kd_rek_4}.${kd_rek_5}.${kd_rek_6}`;
         
         if(!kd_rek_true || kd_rek_2==="" || kd_rek_3==="" || kd_rek_4==="" || kd_rek_5==="" || kd_rek_6==="" || nilai==="" || uraian_rinc===""){
            swal("", "Data rincian rekening belum lengkap", "error");
            return false
         }else{
            if(rincian.length>0){
               for(let i=0; i<temp_str_kd_rek.length; i++) {
                  if(temp_str_kd_rek[i] === kd_rek_123456){
                     swal({
                        title: `Rekening ${kd_rek_123456} sudah ada di rincian ini`,
                        text: "Apakah anda tetap melanjutkan?",
                        icon: "warning",
                        buttons: true,
                        dangerMode: true,
                     })
                     .then((will) => {
                        if (will) {
                           const newRincian = rincian.slice();
                           newRincian[i].nilai = newRincian[i].nilai+nilai;
                           newRincian[i].uraian_rinc = `${newRincian[i].uraian_rinc}, ${uraian_rinc}`;
                           this.setState({
                              data: {
                                 ...this.state.data,
                                 rincian: newRincian
                              },
                           });
                        }
                        this.clearRincian();
                        return false;
                     });
                     return false;
                  }
               }
               this.setState({
                  data: {
                     ...data,
                     rincian: [
                        ...rincian, 
                        {
                           nilai: nilai,
                           uraian_rinc: uraian_rinc,
                           kd_rek_2: kd_rek_2,
                           kd_rek_3: kd_rek_3,
                           kd_rek_4: kd_rek_4,
                           kd_rek_5: kd_rek_5,
                           kd_rek_6: kd_rek_6,
                           str_kd_rek: kd_rek_123456,
                        }
                     ],
                  },
                  temp_str_kd_rek: [...this.state.temp_str_kd_rek, kd_rek_123456],
               });
            }else{
               this.setState({
                  data:{
                     ...data,
                     rincian: [
                        ...rincian, 
                        {
                           nilai: nilai,
                           uraian_rinc: uraian_rinc,
                           kd_rek_2: kd_rek_2,
                           kd_rek_3: kd_rek_3,
                           kd_rek_4: kd_rek_4,
                           kd_rek_5: kd_rek_5,
                           kd_rek_6: kd_rek_6,
                           str_kd_rek: kd_rek_123456,
                        }
                     ],
                  },
                  temp_str_kd_rek: [...this.state.temp_str_kd_rek, kd_rek_123456],
               });
            }               
            this.clearRincian();
         }
      }
   }

   clearRincian(){
      this.statusSelect(true, true, true, true);
      this.clearSelect(true, true, true, true);
      
      getOptRek2()
      .then(resRek => {
         this.setState({opt_rek_2: resRek.data});
         // this.statusSelect(true, true, true, true);
         // this.clearSelect(true, true, true, true);
      });
      // this.setState({
      //    is_manual: !this.state.is_manual,
      //    label_rekening: null,
      //    kd_rek: "",
      // });

      // this.statusSelect(false, true, true, true);
      // this.clearSelect(true, true, true, true);
      this.setState({
         is_edit: false,
         temp: {
            ...this.state.temp,
            manual: {
               ...this.state.temp.manual,
               kd_rek_2: "",
               kd_rek_3: "",
               kd_rek_4: "",
               kd_rek_5: "",
               kd_rek_6: "",
            },
            select: {
               ...this.state.temp.select,
               kd_rek_2: "",
               kd_rek_3: "",
               kd_rek_4: "",
               kd_rek_5: "",
               kd_rek_6: "",
            },
            nilai: "",
            uraian_rinc: "",
            str_kd_rek: ""
         },
         kd_rek: "",
         kd_rek_true: true,
         kd_rek_temp: "",
         label_rekening: null,
      })
   }

   onChangeParaf(e, el){
      this.setState({
         data:{
            ...this.state.data,
            paraf:el.value
         }
      })
   }

   onChangeNilai = (e, maskedvalue, floatvalue) => {
      if((this.state.is_manual && this.state.kd_rek==="") || !this.state.kd_rek_true){
         swal("Harap isi atau lengkapi isian kode rekening terlebih dahulu", {
            icon: "error",
         });
         return false;
      }else{
         this.setState({
            temp: {
               ...this.state.temp,
               nilai:floatvalue
            }
         })
      }
   }
   
   onChange = (e) => {
      let text = e.target.value.replace(/['/%"]/g, '')
      this.setState({
         data: {
            ...this.state.data,
            [e.target.name]:text
         }
      })
   }      

   statusSelect = (a,b,c,d) => this.setState({
      status_rek_3: a,
      status_rek_4: b,
      status_rek_5: c,
      status_rek_6: d,
   })
   
   updateStateTemp(name,value){

      const { kd_rek, temp } = this.state;
      const kd_rek_now = kd_rek==="" ? "4" : kd_rek;
      var kd_rek_23456 = null
      if(name==='kd_rek_2'){
         kd_rek_23456 = {
            kd_rek_2: value,
            kd_rek_3: "",
            kd_rek_4: "",
            kd_rek_5: "",
            kd_rek_6: "",
         }
         this.setState({
            kd_rek: `4.${value}`
         })
      }
      else if(name==='kd_rek_3'){
         kd_rek_23456 = {
            kd_rek_2: this.state.temp.select.kd_rek_2,
            kd_rek_3: value,
            kd_rek_4: "",
            kd_rek_5: "",
            kd_rek_6: "",
         }
         this.setState({
            kd_rek: `4.${this.state.temp.select.kd_rek_2}.${value}`
         })
      }
      else if(name==='kd_rek_4'){
         kd_rek_23456 = {
            kd_rek_2: this.state.temp.select.kd_rek_2,
            kd_rek_3: this.state.temp.select.kd_rek_3,
            kd_rek_4: value,
            kd_rek_5: "",
            kd_rek_6: "",
         }

         this.setState({
            kd_rek: `4.${this.state.temp.select.kd_rek_2}.${this.state.temp.select.kd_rek_3}.${value}`
         })
      }
      else if(name==='kd_rek_5'){
         kd_rek_23456 = {
            kd_rek_2: this.state.temp.select.kd_rek_2,
            kd_rek_3: this.state.temp.select.kd_rek_3,
            kd_rek_4: this.state.temp.select.kd_rek_4,
            kd_rek_5: value,
            kd_rek_6: "",
         }
         this.setState({
            kd_rek: `4.${this.state.temp.select.kd_rek_2}.${this.state.temp.select.kd_rek_3}.${this.state.temp.select.kd_rek_4}.${value}`
         })
      }
      else if(name==='kd_rek_6'){
         kd_rek_23456 = {
            kd_rek_2: this.state.temp.select.kd_rek_2,
            kd_rek_3: this.state.temp.select.kd_rek_3,
            kd_rek_4: this.state.temp.select.kd_rek_4,
            kd_rek_5: this.state.temp.select.kd_rek_5,
            kd_rek_6: value
         }
         this.setState({
            kd_rek: `4.${this.state.temp.select.kd_rek_2}.${this.state.temp.select.kd_rek_3}.${this.state.temp.select.kd_rek_4}.${this.state.temp.select.kd_rek_5}.${value}`
         })
      }

      this.setState({
         temp: {
            ...temp,
            select: kd_rek_23456
         }
      })
   }

   clearSelect = (a, b, c, d) => {
      if(a===true && b===true && c===true && d===true) this.setState({opt_rek_3: null, opt_rek_4: null, opt_rek_5: null, opt_rek_6: null})
      if(b===true && c===true && d===true) this.setState({opt_rek_4: null, opt_rek_5: null, opt_rek_6: null})
      if(c===true && d===true) this.setState({opt_rek_5: null, opt_rek_6: null})
      if(d===true) this.setState({opt_rek_6: null})
   }


   onChangeRek2(e, el){
      this.setState({optrek3: el.value})
      this.statusSelect(false, true, true, true);
      this.clearSelect(true, true, true, true);
      this.updateStateTemp(el.name, el.value);
   }

   getOptRek3 =() => {
      getOptRek3(this.state.optrek3)
      .then(resRek => {
         this.setState({opt_rek_3:resRek.data});
         this.statusSelect(false,false,false,false);
      });
   }

   onChangeRek3(e, el){
      this.setState({optrek4: el.value})
      this.statusSelect(false, false, true, true);
      this.clearSelect(false, true, true, true);
      this.updateStateTemp(el.name, el.value);
   }

   getOptRek4 = () => {
      getOptRek4(this.state.temp.select.kd_rek_2, this.state.optrek4)
      .then(resRek => {
         this.setState({opt_rek_4:resRek.data});
         this.statusSelect(false, false, false, false);
      });
   }

   onChangeRek4(e, el){
      this.setState({optrek5: el.value})
      this.statusSelect(false, false, false, true);      
      this.clearSelect(false, false, true, true);
      this.updateStateTemp(el.name, el.value);
   }

   getOptRek5 = () => {
      getOptRek5(this.state.temp.select.kd_rek_2, this.state.temp.select.kd_rek_3, this.state.optrek5)
      .then(resRek => {
         this.setState({opt_rek_5:resRek.data});
         this.statusSelect(false, false, false, false);
      });
   }

   onChangeRek5(e, el){
      this.setState({optrek6: el.value})
      this.updateStateTemp(el.name,el.value);
      this.statusSelect(false, false, false, false);      
      this.clearSelect(false, false, false, true);
   }

   getOptRek6 = () => {
      getOptRek6(this.state.temp.select.kd_rek_2, this.state.temp.select.kd_rek_3, this.state.temp.select.kd_rek_4, this.state.optrek6)
      .then(resRek => {
         this.setState({opt_rek_6:resRek.data});
         this.statusSelect(false,false,false,false);
      });
   }

   onChangeRek6(e, el){
      this.updateStateTemp(el.name,el.value);
      this.clearSelect(false, false, false, false);
   }

   removeRinc(item, index){
      swal({
         // title: "Warning!",
         text: "Benar akan dihapus?",
         icon: "warning",
         buttons: true,
         dangerMode: true,
       })
      .then((willDelete) => {
         if (willDelete) {
            let { rincian } = this.state.data;
            let str_kd_rek = rincian[index].str_kd_rek;
            var rincian_str_kd_rek = [];
            for(let i=0; i<this.state.temp_str_kd_rek.length; i++) {
               if(this.state.temp_str_kd_rek[i] !== str_kd_rek){
                  rincian_str_kd_rek.push(this.state.temp_str_kd_rek[i])
               }
            }
            
            this.setState({ temp_str_kd_rek: rincian_str_kd_rek })

            let rinci = rincian.slice();
            rinci.splice(index, 1);
            this.setState({ data: { ...this.state.data, rincian: rinci }});
         } 
      });
   }

   onChangeInputRekening(e){
      const input = e.target.value;

      this.setState({
         kd_rek: input,
         requests_label: true,
         kd_rek_temp: input,
         kd_rek_true: false,
         is_edit: true
      });
      
      var count_dot = (input.match(/\./g) || []).length
      
      const kd_rek = input.split(".").filter(i => i);
      const kd_rek_1 = kd_rek[0];
      const kd_rek_2 = kd_rek[1];
      const kd_rek_3 = kd_rek[2];
      const kd_rek_4 = kd_rek[3];
      const kd_rek_5 = kd_rek[4];
      const kd_rek_6 = kd_rek[5];
      if(kd_rek.length === 6){
         if(kd_rek_1==="4"){
            if(count_dot === 5){
               fetch(`${BaseURLDev}/simantra/ref/searchrek6?kd_rek_1=${kd_rek_1}&kd_rek_2=${kd_rek_2}&kd_rek_3=${kd_rek_3}&kd_rek_4=${kd_rek_4}&kd_rek_5=${kd_rek_5}&kd_rek_6=${kd_rek_6}`,
                  { headers })
               .then(response => {
                     if (!response.ok) { 
                        this.setState({
                           requests_label: false,
                           kd_rek_true: false,
                           label_rekening: "Rekening kurang tepat atau periksa koneksi internet anda",
                           rekening_error: true,
                           header_message: "Ralat rekening",
                        })
                        Promise.reject(response.statusText);
                     }
                     return response.json();
                  })
               .then(resJSON => {
                  if(resJSON.status){
                     this.setState({
                        requests_label: false,
                        rekening_error: false,
                        kd_rek_true: true,
                        header_message: "Rekening ditemukan",
                        label_rekening: resJSON.messages,
                        temp: {
                           ...this.state.temp,
                           manual: {
                              ...this.state.temp.manual,                        
                              kd_rek_2: kd_rek_2,
                              kd_rek_3: kd_rek_3,
                              kd_rek_4: kd_rek_4,
                              kd_rek_5: kd_rek_5,
                              kd_rek_6: kd_rek_6,
                           }
                        },
                     })
                  }else{
                     this.setState({
                        requests_label: false,
                        kd_rek_true: false,
                        label_rekening: `Rekening ${kd_rek} tidak ditemukan, mohon dikoreksi kembali`,
                        rekening_error: true,
                        header_message: "Ralat rekening",
                     })
                  }
               });
            }else{
               this.setState({
                  // kd_rek:"",
                  kd_rek_true: false,
                  requests_label: false,
                  rekening_error: true,
                  header_message: "Ralat rekening",                  
                  label_rekening: `Rekening ${kd_rek} kurang tepat, mohon dikoreksi kembali`
               })
               return false;
            }
         }else{
            this.setState({
               kd_rek_true: false,
               rekening_error: true,
               header_message: "Ralat rekening",
               requests_label: false,
               label_rekening: "Harus rekening pendapatan yang berawalan 4"
            })
         }
      }else{
         if(kd_rek.length === 0){
            this.setState({
               requests_label: false,
               label_rekening: null,
               rekening_error: true
            })                        
         }else if(kd_rek.length < 6){
            this.setState({
               requests_label: false,
               label_rekening: null,
               rekening_error: true
            })            
         }else if(kd_rek.length > 6){
            this.setState({
               requests_label: false,
               label_rekening: null,
               rekening_error: true
            })                        
         }
      }
   }

   onReset(){
      swal({
         // title: "Warning!",
         text: "Benar data form akan dihapus?",
         icon: "warning",
         buttons: true,
         dangerMode: true,
       })
      .then((willDelete) => {
         if (willDelete) {
            this.resetState()
            swal("Semua data form telah dihapus", {
               icon: "success",
            });
         } 
      });
   }

   onOpenAddSTS = () => {
      const { rincian, nama_penyetor, alamat_penyetor, paraf } = this.state.data;
      if(rincian.length < 1){
         swal("Maaf rincian rekening belum ditambahkan", {
            icon: "error",
         });
      }

      else if(alamat_penyetor===null || alamat_penyetor===""){
         swal("Alamat penyetor harus diisi terlebih dahulu", {
            icon: "error",
         });
         return false;
      }else if(paraf===null || paraf===""){
         swal("Pejabat/pegawai harus diisi terlebih dahulu", {
            icon: "error",
         });
         return false;

      }else if(nama_penyetor==="" || nama_penyetor===null){
         swal("Nama penyetor harus diisi terlebih dahulu", {
            icon: "error",
         });
         return false;

      }else{
         this.setState({loading_open:true})
         setTimeout(()=>{
            this.setState({
               is_open:true,
               loading_open:false,
               data_bp:this.state.data,
            });
         }, 50)
      }
   }

   onCloseAddSTS = () => {
      this.setState({
         is_open:false,
         // data_post:[]
      });
   }
   
   render() {

      const {nama_penyetor, alamat_penyetor, uraian, rincian} = this.state.data;
      const {error, loading, kd_rek, rekening_error} = this.state;
      const {nilai, uraian_rinc} = this.state.temp
      var count = 0;
      var counter = 0;

      if(rincian.length!==0){
         rincian.map(function(item, i){
            count=count+item.nilai
            counter=counter+(i+1)
         })
      }
      return (
      <div>
         <Message
               error
               header='** Penting'
               content='BP ini hanya bisa dibuat jika user login menggunakan tahun anggaran yang sama pada tahun saat ini. Kolom uraian atau keterangan pembayaran rekening dan keterangan BP harus diisi dan jika ingin langsung membuat STS klik tombol Langsung STS'
            />
         <Menu>
            <Menu.Item>
               <Button.Group size='small'>
                  <Button content="Simpan BP" 
                     color='green' icon='save' disabled={this.state.disabled_btn_save} onClick={this.onSubmit} />
                  <Button content="Hapus data form" 
                     color='red' 
                     icon='trash' onClick={this.onReset} />
                  <Button color='blue' 
                     content="Langsung STS" 
                     icon='refresh' onClick={this.onOpenAddSTS} />                        
               </Button.Group>
            </Menu.Item>
            <Menu.Item>
               <h3>Membuat BP Baru</h3>
            </Menu.Item>
         </Menu>
         <Grid>         
            <Grid.Column width={8}>
               <Segment padded>
                  <Label attached='top' color="violet">Rincian rekening</Label>
               {/*start of rincian=====================================================================================================*/}            
                  <Popup
                     trigger={
                        <Radio toggle style={{marginBottom:'10px'}}
                           onChange={this.onToggleRadio}/> 
                     }
                     header="Toggle Rekening"
                     content='Manual input atau memilih list'
                     // on='hover'
                     inverted
                  />
                  {this.state.label_rekening!==null &&
                     <Message
                        error={rekening_error}
                        success={!rekening_error}
                        header={this.state.header_message}
                        content={this.state.label_rekening}
                     />
                  }
                  <Form loading={loading}>
                     {this.state.is_manual ?
                        <Form.Field>
                           <Input 
                              loading={this.state.requests_label}
                              value={kd_rek}
                              autoFocus
                              icon='credit card' 
                              autoComplete="off"
                              onChange={(e)=>this.onChangeInputRekening(e)} 
                              name="kd_rek"
                              placeholder="contoh 4.1.1.1.1.1"   
                           />
                           
                        </Form.Field>
                        :
                        <div>
                           
                           <Form.Field>
                              <Input 
                                 disabled={true}
                                 placeholder='[4] PENDAPATAN'
                              />
                           </Form.Field>
                           <Popup
                              trigger={
                                 <Form.Field control={Select} search //loading={this.state.status_rek_2} 
                                 disabled={this.state.status_rek_2}
                                 onChange={this.onChangeRek2} 
                                 options={this.state.opt_rek_2} name="kd_rek_2"
                                 placeholder='Pilih rekening ke 2' />}
                              content='Pilih rekening ke 2'
                              // on='hover'
                              inverted
                           />
                           <Popup
                              trigger={
                                 <Form.Field search //loading={this.state.status_rek_3} 
                                 disabled={this.state.status_rek_3}
                                 control={Select} 
                                 onClick={this.getOptRek3}
                                 onChange={this.onChangeRek3} 
                                 options={this.state.opt_rek_3} name="kd_rek_3" 
                                 placeholder='Pilih rekening ke 3' />}
                                 content='Pilih rekening ke 3'
                                 // on='hover'
                                 inverted
                           /> 
                           <Popup
                              trigger={
                                 <Form.Field control={Select} search //loading={this.state.status_rek_4} 
                                    disabled={this.state.status_rek_4}
                                    onChange={this.onChangeRek4} 
                                    onClick={this.getOptRek4}
                                    options={this.state.opt_rek_4} name="kd_rek_4" 
                                    placeholder='Pilih rekening ke 4' />}
                              content='Pilih rekening ke 4'
                              // on='hover'
                              inverted
                           />             
                           <Popup
                              trigger={
                                 <Form.Field control={Select} search //loading={this.state.status_rek_5} 
                                 disabled={this.state.status_rek_5}
                                 onChange={this.onChangeRek5} 
                                 onClick={this.getOptRek5}
                                 options={this.state.opt_rek_5} name="kd_rek_5" 
                                 placeholder='Pilih rekening ke 5' />}
                              content='Pilih rekening ke 5'
                              // on='hover'
                              inverted
                           />

                           <Popup
                              trigger={
                                 <Form.Field control={Select} search //loading={this.state.status_rek_6} 
                                 disabled={this.state.status_rek_6}
                                 onChange={this.onChangeRek6} 
                                 onClick={this.getOptRek6}
                                 options={this.state.opt_rek_6} name="kd_rek_6" 
                                 placeholder='Pilih rekening ke 6' />}
                              content='Pilih rekening ke 6'
                              // on='hover'
                              inverted
                           />
                        <br />                         
                        </div> 
                     }
                     <Popup
                        trigger={
                           <CurrencyInput autoComplete="off" decimalSeparator="," precision="2" value={nilai} 
                              thousandSeparator="."
                              onChangeEvent={this.onChangeNilai} name="nilai" />}
                        content='Nilai yang disetor'
                        // on='focus'
                        inverted
                     />
                     
                        <Form.TextArea style={{marginTop:'10px'}} value={uraian_rinc} 
                           onChange={(e) => {
                              let text = e.target.value.replace(/['/%"]/g, '')
                              this.setState({temp:{...this.state.temp,uraian_rinc:text}})
                           }} 
                           onKeyPress={this.handleKeyPress}
                           placeholder='Untuk Pembayaran ...'
                           title='Untuk Pembayaran ...' name="uraian_rinc" />
                     
                     <Button.Group size='tiny' style={{marginTop:'15px'}}>
                        <Button 
                           /*disabled={!is_enabled_rincian}*/
                           label={{ basic: true, color: 'red', pointing: 'left', content: toIDR(count) }}
                           color="blue" 
                           onClick={this.onSubmitRincian}
                           content="Tambah rincian"
                        />
                     </Button.Group>
                  </Form><br />
                  {rincian.length!==0 &&
                     <RincianList rincian={rincian} edit={this.editRinc} removeRinc={this.removeRinc}/>
                  }
                  
            </Segment>
         </Grid.Column>
         <Grid.Column width={8}>         
            {/*start of data pelengkap=====================================================================================================*/}
            <Segment padded>
               <Label attached='top' color="violet">Data input Bukti Penerimaan</Label>
               <Form error={error} loading={loading}>
                  {/*<DatePicker
                     selected={moment()}
                     onChange={this.handleChangeDate}
               />*/}
                  <Form.Field 
                     control={Select} 
                     search 
                     onChange={this.onChangeParaf} 
                     options={this.state.parafs} 
                     name="paraf" 
                     placeholder='Pilih pejabat/pegawai penerima'
                     ttile='Pilih pejabat/pegawai penerima'
                     // value={nama_penyetor}
                  />
                  {/*name={input.name}
                     options={options}
                     label={label}
                     placeholder={placeholder}
                     search
                     multiple
                     selectOnBlur={selectOnBlur}
                     onFocus={::this.handleFocus}
                     onBlur={::this.handleBlur}
                     onChange={::this.handleChange}
                     defaultValue={defaultValue || []}
                     value={input.value}
                     loading={loading}*/}
                  <Form.Input value={nama_penyetor} onChange={this.onChange} onKeyPress={this.handleKeyPress}
                     name="nama_penyetor" placeholder='Nama penyetor'
                     title='Nama penyetor' />               

                  <Form.TextArea value={alamat_penyetor} onChange={this.onChange} onKeyPress={this.handleKeyPress}
                     placeholder='Alamat penyetor'
                     title='Alamat penyetor' name="alamat_penyetor" />

                  <Form.TextArea value={uraian} onChange={this.onChange} onKeyPress={this.handleKeyPress}
                     placeholder='Keterangan BP' name="uraian" 
                     title='Keterangan BP'/>
               </Form>
               
               <Button.Group size='small' style={{'marginTop':'10px'}}>
                  <Button content="Simpan BP" 
                     color='green' icon='save' onClick={this.onSubmit} />
                  <Button content="Hapus data form" 
                     color='red' 
                     icon='trash' onClick={this.onReset} />
                  <Button color='blue' 
                     content="Langsung STS" 
                     icon='refresh' onClick={this.onOpenAddSTS} />                        
               </Button.Group>
                  
            </Segment>
         </Grid.Column>
         {/*<Grid.Column width={16}>
            
         </Grid.Column>
         
      end of rincian=====================================================================================================*/}
      
      </Grid>                        
      {/*end of data pelengkap=====================================================================================================*/}      
      {this.state.is_open && 
         <STSAdd
            open={this.state.is_open}
            data_bp={this.state.data_bp} 
            onClose={this.onCloseAddSTS} />
      }
      </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/BPAdd.js